'use client';

import { useState } from 'react';
import Image from "next/image";
import getAPI from '@/services/api';
import { useRouter } from 'next/navigation'
import { InitData, useInitData, useLaunchParams } from '@telegram-apps/sdk-react';
import { Spinner } from '@telegram-apps/telegram-ui';

const LAUNCH_DATE = process.env.NEXT_PUBLIC_LAUNCH_DATE || '';
const FARMING_DAYS = process.env.NEXT_PUBLIC_FARMING_DAYS || '';
const NXTT_START_PRICE_STR = process.env.NEXT_PUBLIC_NXTT_START_PRICE_STR || "";

export default function Home() {

  const [dataLoaded, setDataLoaded] = useState(false);
  const api = getAPI();
  const initDataRaw = useLaunchParams().initDataRaw;
  const initData = useInitData();
  const [userId, setUserId] = useState('')
  const [referralId, setReferralId] = useState('')
  const router = useRouter()
  const [price, setPrice] = useState(0);
  const [percentChange, setPercentChange] = useState(0);
  const [farmingDay, setFarmingDay] = useState(0);
  const [percentCalculated, setHasPercent] = useState<boolean>(false)

  async function loadData(referralId:string = '') {
    setDataLoaded(true);    
    try {
      if (initData && initData.user && initData.user.id) {
        localStorage.setItem('userId', `${initData.user.id}`);
      }
      await api.postData('user/login', { data: initData, referralId: referralId });

      const farmindDates = calculateFarming(LAUNCH_DATE, parseInt(FARMING_DAYS));
      setFarmingDay(farmindDates);

      const storedModal = localStorage.getItem(`Modal`);
      if (storedModal != null) {
        localStorage.removeItem(`Modal`);
      }

      const farm = await api.fetchData('farm/get-farming-status');
      if (farm.reachedNewLevel) {
        setTimeout(() => {
          router.push('/daily?referrer=start');
        }, 4000);
      } else {
        setTimeout(() => {
          router.push('/home');
        }, 4000);
      }
    } catch (e) {
      alert(e)
      return
    }
  }

  async function fetchNxttPriceData() {
    try {
        const response = await api.fetchData('farm/get-nxtt');
        const apiPrice = parseFloat(response.price.toFixed(8));
        setPrice(apiPrice);
        const number =  parseFloat(NXTT_START_PRICE_STR);
        const price = (((apiPrice / number) * 100) - 100);
        const percent = price; 
        setPercentChange(percent);
        setHasPercent(true);
    } catch (e) {
      console.log(e);
      setPercentChange(0.0);
      setHasPercent(true);
    }
  }

  const initWebApp = async () => {
    if (typeof window !== 'undefined') {
      const WebApp = (await import('@twa-dev/sdk')).default;
      WebApp.ready();
      
      setUserId(WebApp.initDataUnsafe.user?.id.toString() || '');
      setReferralId(WebApp.initDataUnsafe.start_param || '');
    
    }
  };

  const setParams = async (initDataRaw: string | undefined, initData:InitData | undefined) => {
    if (initDataRaw) {
      localStorage.setItem('initDataRow', initDataRaw);
    }
    if (initData) {
      localStorage.setItem('userId', userId);
      localStorage.setItem('hash', initData?.hash);
    }
    let refId = "";
    if (referralId) {
      refId = referralId;
    }
    loadData(refId);
  }

  if (dataLoaded == false) {
    fetchNxttPriceData();
    initWebApp();
    setParams(initDataRaw, initData);
  }

  const calculateFarming = (launchDate:string, farmingDays:number) => {
    // Parse the launchDate
    const launchDateParsed = new Date(launchDate);

    // Calculate the farming end date
    const farmingEndDate = new Date(launchDateParsed);
    farmingEndDate.setDate(farmingEndDate.getDate() + farmingDays);

    // Get the current date in UTC
    const currentDate = new Date();
    const currentDateUTC = new Date(Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getUTCDate()
    ));

    // Calculate remaining days
    const timeDifference = farmingEndDate.getTime() - currentDateUTC.getTime();
    const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    // Return the results
    return daysLeft > 0 ? daysLeft : 0;
  }

  return (
    <div className={`w-full my-5`}>

      <div className="relative inline-block flex flex-row mt-10">
        <div className="flex-0 mx-auto">
          <div className="flex flex-row gap-4 mx-auto items-center justify-center ">
            
            <div className='flex-0'>
              <svg width="70" height="70" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M128.023 21.9767C98.7209 -7.32558 51.2791 -7.32558 21.9767 21.9767C-7.32558 51.2791 -7.32558 98.7209 21.9767 128.023C51.2791 157.326 98.7209 157.326 128.023 128.023C157.326 98.7209 157.326 51.2791 128.023 21.9767ZM119.053 119.85C107.093 131.013 77.99 120.449 53.8704 96.3289C29.7508 72.2093 19.186 42.1096 30.7475 30.5482C42.5083 18.588 58.4552 12.2093 75.1993 12.2093C91.9435 12.2093 107.691 18.7874 119.651 30.5482C143.97 54.8671 144.169 94.5349 119.85 119.053L119.452 119.651C119.252 119.651 119.252 119.651 119.053 119.85Z" fill="white" fillOpacity="0.9" />
              </svg>
            </div>
            <div className="flex-0 ">
              <h2 className="text-center font-poppins text-white text-4xl font-medium uppercase">Next Earth</h2>
              <div className='mt-2 text-right'>
                <span className='me-2 font-medium'>Mini App</span><span className='ne-gradient font-medium rounded-md px-2 py-0'>Beta</span>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div className='text-center mt-10'>
        {percentCalculated ? <p className='mx-auto inline-block text-left text-md text-white flex flex-row items-center justify-center'><span className='text-[#EA408D] text-lg font-medium'>$NXTT:</span> <span className='ms-3 me-3 text-md'>${price.toFixed(7)}</span> <span className={(percentChange < 0) ? 'text-[red] text-xs' : 'text-[green] text-xs'}>{(percentChange > 0) ? '+' : ''}{percentChange.toFixed(2)}%</span></p> : <div className='mx-auto inline-block text-center'><Spinner className={`!text-white mx-auto`} size="s" /></div>}
        <p className='text-white/50 text-sm mt-1 mb-2'>Since Mini App Launch</p>
      </div>
      <div className="my-0 max-w-[70%] mx-auto py-5 mt-3 relative">
        <Image src="/images/simple-planet.png" alt="NextEarth - Planet image"
          layout="responsive"
          className="max-w-[230px] mx-auto"
          width={50}
          height={50}
          objectFit="cover" />
          <div className={`absolute top-3 left-3 right-3 bottom-3 flex items-center justify-center`}>

          <Image src="/images/loading.png" alt="NextEarth - Planet image"
            layout="responsive"
            className="max-w-[140px] mx-auto animate-[spin_2s_linear_infinite]"
            width={120}
            height={120}
            objectFit="cover" />

          </div>
      </div>


  
      <div className='mt-2'>
        <div className="ne-gradient py-3 max-w-[320px] mx-auto text-white text-center rounded-xl text-sm font-medium px-2 py-1"> Farming ends in: {farmingDay} days!</div>
      </div>

  
    </div>
  );
}
